import { canv } from '@/canv/global.js'
import { toolBase } from '@/tools/toolBase';

import { eventEmitter } from '@/eventEmitter';

export class moreTool extends toolBase {
    constructor() {
        super();
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M12 5V19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Больше инструментов";
    }

    select() {
        super.select();

        eventEmitter.dispatch("moreTool.visibility", { isVisible: true });
    }

    unselect() {
        super.unselect();

        eventEmitter.dispatch("moreTool.visibility", { isVisible: false });
        canv.appInterface.stickersWindow.close();
    }

    TryAction(type) {
        if (type == "mousedown") {
            canv.toolBox.switchToByName("cursorTool");
        }
    }

    draw() { }

    name = "moreTool";
}
